<template>
  <div class="textual-review-detail">
    <div class="header fjcsb">
      <span>{{ info.patientInfoStr }}</span>
      <Icon class="close-icon" type="md-close" @click="close" />
    </div>
    <div class="content">
      <div class="mk">
        <div class="row">
          <div class="row-item">
            <span class="label">医馆：</span>
            <span class="value">{{ info.hospitalName }}</span>
          </div>
          <div class="row-item">
            <span class="label">被检视人：</span>
            <span class="value">{{ info.employeeInfoStr }}</span>
          </div>
          <div class="row-item">
            <span class="label">检视日期：</span>
            <span class="value">{{ info.checkDate }}</span>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <span class="label">检视类别：</span>
            <span class="value">{{
              info.checkType == "2" ? "非亲和力" : "亲和力"
            }}</span>
          </div>
        </div>
      </div>
      <div class="mk">
        <div class="mk-title">检视结果</div>
        <div class="mk-value" v-html="info.remark"></div>
      </div>
      <div class="mk">
        <div class="mk-title">被扣分项目</div>
        <div class="mk-value">
          <dTable v-if="info.mvsResult != 2" :info="info" />
          <div v-else>无被扣分项目</div>
        </div>
      </div>
      <template v-if="info.doctorReplyType != 0">
        <div class="mk">
          <div class="mk-title">医生回复</div>
          <div class="mk-value">
            <div
              class="item"
              v-for="(item, index) in doctorCheckReplyLst"
              :key="index"
            >
              <span class="time">{{ item.crDt }}回复：</span>
              <span>{{
                item.replyType == 1 ? "同意检视结果" : "反对检视结果"
              }}</span>
              <span v-if="item.replyResult">；{{ item.replyResult }}</span>
            </div>
          </div>
          <div class="mk-value" v-if="[10, 20].includes(info.doctorReplyType)">
            <uformCreate
              ref="uformCreateRef"
              :hideConfirmBtn="true"
              :hideCancelBtn="true"
              :list="formInputList"
              :labelPosition="labelPosition"
              @submit="submit"
              @close="close"
            />
          </div>
        </div>
        <div class="mk">
          <div class="mk-title">检视方回复</div>
          <div class="mk-value">{{ info.checkReply || "暂无回复" }}</div>
        </div>
      </template>
    </div>
    <div class="footer" v-if="[10, 20].includes(info.doctorReplyType)">
      <Button type="primary" @click="onSubmit">确认回复</Button>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import dTable from "./dTable.vue";
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      doctorCheckReplyLst: [],
      formInputList: [],
      labelPosition: "top",
    };
  },
  watch: {
    info(newValue, oldValue) {
      this.init();
    },
  },
  components: {
    dTable,
  },
  methods: {
    doctorCheckReplyData() {
      this.doctorCheckReplyLst = [];
      if (this.info.doctorReplyType >= 11) {
        request
          .post("/saasbaihui/doctorCheckReplyData", { dcId: this.info.dcId })
          .then((res) => {
            this.doctorCheckReplyLst = res.result;
          });
      }
    },
    onSubmit() {
      this.$refs.uformCreateRef.submitForm();
    },
    submit(obj) {
      this.$Modal.confirm({
        title: "提示",
        content: "确认回复吗？",
        onOk: () => {
          obj.dcId = this.info.dcId;
          request.post("/saasbaihui/yzDoctorCheckReply", obj).then((res) => {
            this.$Message.success(res.result);
            this.$emit("change");
            this.close();
            this.$store.dispatch("todoNumber");
          });
        },
      });
    },
    close() {
      this.$emit("close");
    },
    setFormInputList() {
      let tool = null;
      if (this.$refs.uformCreateRef) {
        tool = this.$refs.uformCreateRef.tool;
      }
      this.formInputList = [
        {
          type: "radio",
          field: "replyType",
          title: "是否同意检视结果",
          value: "",
          required: true,
          option: [
            {
              label: "同意检视结果",
              value: "1",
            },
            {
              label: "反对检视结果",
              value: "2",
            },
          ],
          change: (val) => {
            tool().setInputs(["replyResult"], {
              isHide: val == "1" ? true : false,
            });
          },
        },
        {
          type: "textarea",
          field: "replyResult",
          title: "反对原因",
          value: "",
          required: true,
          isHide: true,
        },
      ];
    },
    init() {
      this.$nextTick(() => {
        this.setFormInputList();
      });
      this.doctorCheckReplyData();
    },
  },
  mounted() {
    this.$store.dispatch("getWideUseList", "BH_DOCTOR_CHECK").then((res) => {
      this.init();
    });
  },
};
</script>

<style lang="scss" scoped>
.textual-review-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    font-weight: bold;
    font-size: 16px;
    height: 40px;
    flex-shrink: 0;
    line-height: 40px;
    border-bottom: 1px solid #eee;
    .close-icon {
      cursor: pointer;
      padding: 5px;
    }
  }
  .content {
    height: 100%;
    overflow-y: auto;
    line-height: 2em;
    .row {
      display: flex;
      & > div {
        flex: 1;
      }
    }
    .mk {
      margin-bottom: 10px;
      .mk-title {
        font-weight: bold;
        font-size: 15px;
      }
    }
    .time {
      color: #999;
    }
  }

  .footer {
    border-top: 1px solid #eee;
    padding: 10px 15px 0;
    text-align: center;
  }
}
</style>